import React from "react";

import { Button } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { showRetailZoneInfo } from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";
import { useAppDispatch } from "store";

const Open: React.FC = () => {
    const theme = useTheme();
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(showRetailZoneInfo());
    };

    return (
        <Button
            onClick={handleClick}
            endIcon={<InfoOutlinedIcon />}
            style={{ marginLeft: -theme.spacing(1.5) }}
        >
            Find out more about retail zones
        </Button>
    );
};

export default Open;
